import React from 'react';
import { reduxForm, isDirty, Field, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import {
  onClickCancel,
  onClickCreateItem,
  onChangeFilterItemHub,
} from 'actions/businessLibrary/item';
import MenuTitle from 'components/MenuTitle';
import SearchBar from 'components/Fields/ReduxForm/SearchBar';
import DropdownSelect from 'components/Fields/ReduxForm/DropdownSelect';

import styles from './ActionBar.css';

const cx = classNames.bind(styles);

class ActionBar extends React.Component {
  static NAMESPACE_OPTIONS = [
    {
      id: 'items',
      name: 'Item Library',
    },
    {
      id: 'ingredients',
      name: 'Ingredients',
    },
  ];

  render() {
    const {
      isWriteMode,
      categories,
      loadingSpinner: { showLoadingSpinnerPage },
    } = this.props;

    return (
      <div
        className={`${styles.wrapper} ${this._getActionbarClassNames(
          isWriteMode
        )}`}
      >
        <MenuTitle
          column={6}
          menuTitle="Item Library"
          subTitle="Business Level"
          additionalClassName="sub-title"
        />
        {!isWriteMode && (
          <div
            className={`hidden-xs hidden-sm col-lg-6 col-md-6 col-sm-6 col-xs-6 action-item ${
              styles['float-action-bar']
            }`}
          >
            <span className="pull-right">
              <ul
                className={`${styles['ul-filter']} ${styles['filter-right']}`}
              >
                <li
                  className={`${
                    styles['li-filter-right']
                  } li-total-item visible-md visible-lg`}
                >
                  <button
                    className="btn btn-primary"
                    onClick={this._onClickCreateItem}
                    disabled={showLoadingSpinnerPage}
                  >
                    Add Item
                  </button>
                </li>
              </ul>
            </span>
          </div>
        )}
        {isWriteMode && (
          <div
            className={`col-lg-12 col-md-12 col-sm-12 col-xs-12 action-item ${
              styles['breadcrumb-container']
            }`}
          >
            <hr className={styles['breadcrumb-divider']} />
            <div className={styles['container-breadcrumb']}>
              <div className={styles['breadcrumb-contain']}>
                <span
                  className={styles['breadcrumb-title-opacity']}
                  onClick={this._backitemLibrary}
                >
                  Business Library
                </span>
                <span className={styles['breadcrumb-arrow']} />
                <span className={styles['breadcrumb-title-opacity']}>Item</span>
                <span className={styles['breadcrumb-arrow']} />
                <span> Add Item </span>
              </div>
            </div>
            <hr className={styles['breadcrumb-divider']} />
          </div>
        )}
        {!isWriteMode && (
          <div className="col-xs-12 no-padding">
            <span className="pull-left">
              <ul className={styles['ul-filter']}>
                <li className={`${styles['li-filter']} li-dropdown-category`}>
                  <Field
                    name="categoryId"
                    component={DropdownSelect}
                    options={categories}
                    defaultOption={{ id: 0, name: 'All Categories' }}
                    className="dropdown-select-categories"
                    id="filterSelectCategory"
                    onChange={this._onChangeFilterCategory}
                    disabled={false}
                  />
                </li>
                <li className={`${styles['li-filter']} li-searching`}>
                  <Field
                    name="search"
                    component={SearchBar}
                    placeholder="Search"
                    onChange={this._onChangeFilterSearch}
                  />
                </li>
              </ul>
            </span>
          </div>
        )}
      </div>
    );
  }

  _onChangeFilterCategory = (_, categoryId) => {
    const { dispatch, filterForm } = this.props;
    const { search, outletIds } = filterForm;
    dispatch(
      onChangeFilterItemHub({
        categoryId,
        outletId: outletIds[0],
        keyword: search,
      })
    );
  };

  _onChangeFilterSearch = (event, search) => {
    const { dispatch, filterForm } = this.props;
    const { outletIds, categoryId } = filterForm;
    dispatch(
      onChangeFilterItemHub({
        categoryId,
        outletId: outletIds[0],
        keyword: search,
      })
    );
  };

  _backitemLibrary = () => {
    const { dispatch } = this.props;
    dispatch(onClickCancel());
  };

  _onClickCreateItem = () => {
    const { dispatch } = this.props;

    dispatch(onClickCreateItem());
  };

  _getActionbarClassNames = isWriteMode => {
    return cx({
      'library-action-bar': !isWriteMode,
    });
  };
}

const mapForm = {
  form: 'search',
};

const selector = formValueSelector('search');

function mapStateToProps(state) {
  const { itemMeta, isWriteMode, categories } = state.businessLibrary.itemHub;
  const isDirtyItem = isDirty('itemHub')(state);
  const {
    subscriptionStatus: { is_active },
  } = state.inventory.ingredientSubscription;
  const { loadingSpinner } = state;

  const { categoryId, search, outletIds } = selector(
    state,
    'categoryId',
    'typeInventoryId',
    'search',
    'outletIds'
  );

  return {
    loadingSpinner,
    categories,
    itemMeta,
    isWriteMode,
    isDirtyItem,
    isIngredientActive: is_active,
    filterForm: { categoryId, search, outletIds },
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm(mapForm)(ActionBar));
